import { FC, useEffect, useState } from "react";
import AuthLayout from "layouts/AuthLayout/AuthLayout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PropTypes } from "./Login.types";
import { tx } from "modules/language/translate";
import { LoginForm } from "components/forms/auth/LoginForm";
import { AnnouncementBanner } from "src/components/banners/AnnouncementBanner";

import "components/forms/auth/AuthForms.scss";

import { Link, Text, Heading, Layout } from "frontend-components";
import { saveBlockedRoute } from "src/routes/ProtectedRoute";


/**
 * If the redirect-url is a login page, return null. Otherwise, return the redirect-url.
 * @param searchParams
 * @returns string | null
 */
const getRedirectUrl = (searchParams: URLSearchParams) => {
  const redirectUrl = searchParams.get("redirect-url");
  if (redirectUrl && decodeURI(redirectUrl).startsWith("/login")) {
    return null;
  }
  return redirectUrl;
};

const Login: FC<PropTypes> = () => {
  const navigate = useNavigate();
  const [cooldown, setCooldown] = useState(false);
  const [searchParams] = useSearchParams();
  const redirectUrl = getRedirectUrl(searchParams);

  // Login page may have a redirect back to the old dashboard's login page
  useEffect(() => {
    if (redirectUrl) {
      saveBlockedRoute(true, redirectUrl);
    }
  }, [redirectUrl]);

  const onSuccess = () => {
    if (redirectUrl) {
      window.location.href = decodeURI(redirectUrl);
    } else {
      navigate("/");
    }
  };

  const registerLink = `/register${
    redirectUrl ? `?redirect-url=${redirectUrl}` : ""
  }`;

  return (
    <AuthLayout
      showMessaging={true}
      form={
        <Layout flow="top-bottom" gap="md">
          {!cooldown && (
            <>
              <Heading size="h2" margin="none">
                {tx("auth.messages.welcome")}
              </Heading>
              {(window as any)?.Cypress !== undefined ? (
                <Text size="lg" bold>
                  {tx("auth.messages.new_user")}{" "}
                  <Link href={registerLink}>{tx("auth.actions.sign_up")}.</Link>
                </Text>
              ) : (
                <AnnouncementBanner rounded={true} />
              )}
            </>
          )}
          <LoginForm
            onCooldown={() => setCooldown(true)}
            onCooldownOff={() => setCooldown(false)}
            onSuccess={onSuccess}
          />
        </Layout>
      }
    />
  );
};

export default Login;
